import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const FAQS = [
    {
        q: "How do I book a tour with Vistaaryatra?",
        a: "Submit the online booking form, send us a WhatsApp message or call us. A travel designer will understand your preferences, prepare a custom itinerary and quote, and confirm your trip once you approve.",
    },
    {
        q: "Can I customise my itinerary?",
        a: "Absolutely — that is our speciality. Every Vistaaryatra journey is tailor-made. Tell us your dates, pace, budget and interests, and we will design the route around you.",
    },
    {
        q: "What is typically included in a package?",
        a: "Most packages include accommodation, private transfers, sightseeing with an English-speaking driver or guide, and applicable permits. Flights and trains can be added on request. Every quote lists inclusions and exclusions clearly.",
    },
    {
        q: "What documents do I need for domestic travel in India?",
        a: "A government-issued photo ID (Aadhaar, passport, driving licence) is required for hotels and flights. Some regions such as Ladakh or parts of the North East need inner-line permits — we arrange those for you.",
    },
    {
        q: "What are your payment and cancellation policies?",
        a: "A modest advance confirms your booking, with the balance due before departure. Cancellation terms are shared upfront in writing — the closer to departure, the higher the fee, and some seasonal stays have stricter rules which we always flag in advance.",
    },
    {
        q: "Do you support travellers during the trip?",
        a: "Yes. A 24/7 helpline travels with you. Flight delays, route changes, medical assistance — one call and our on-ground team takes over.",
    },
];

export const Faq = () => (
    <section className="bg-cream py-24 lg:py-32" data-testid="faq-section">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
            <SectionHeading
                eyebrow="Good To Know"
                title="Frequently asked questions"
                align="center"
            />
            <Reveal delay={0.15} className="mt-14">
                <Accordion type="single" collapsible className="w-full">
                    {FAQS.map((faq, i) => (
                        <AccordionItem key={i} value={`faq-${i}`} className="border-border" data-testid={`faq-item-${i}`}>
                            <AccordionTrigger className="text-left font-serif text-lg font-semibold text-navy hover:text-brass-dark hover:no-underline">
                                {faq.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-sm leading-relaxed text-steel">
                                {faq.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);
